import React from "react";
import { Link } from "react-router-dom";
import { HalalBadge } from "@/components/HalalBadge";
import { CandyDripDivider } from "@/components/CandyDripDivider";
import { E } from "@/components/Editable";
import { useDevice, dv } from "@/components/Device";
import { mediaUrl } from "@/lib/api";

export function Footer() {
  const device = useDevice();
  return (
    <footer className={`border-t border-border bg-gradient-to-b from-secondary/50 to-background ${device === "mobile" ? "mt-10" : "mt-20"}`}>
      <E id="drip" label="Bølge-grafik" display="block"><CandyDripDivider /></E>
      <div className={`mx-auto grid max-w-7xl gap-8 px-4 ${dv(device, { desktop: "grid-cols-4 py-12", tablet: "grid-cols-2 py-10", mobile: "grid-cols-1 py-8" })}`}>
        <div>
          <div className="mb-3 flex items-center gap-2">
            <E id="logo" label="Footer-logo" kind="image">{(el) => <img src={el.src ? mediaUrl(el.src) : "/brand/logo.png"} alt="BARE 1 MERE" className="h-12 w-12 rounded-full" />}</E>
            <E id="brand" label="Brandnavn" kind="text">{(el) => <span className="font-brand text-lg font-bold">{el.text || <>BARE <span className="text-primary">1</span> MERE</>}</span>}</E>
          </div>
          <E id="desc" label="Beskrivelse" kind="text" display="block">{(el) => <p className="mb-3 text-sm text-muted-foreground">{el.text || "Danmarks lækreste udvalg af 100% halal slik, chokolade og godter."}</p>}</E>
          <E id="halal" label="HALAL-mærke" kind="text">{(el) => <HalalBadge size="sm" text={el.text} />}</E>
        </div>
        <E id="col-shop" label="Kolonne: Shop" display="block">
        <div>
          <h4 className="mb-3 text-sm font-bold uppercase tracking-wide">Shop</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/produkter" className="hover:text-primary">Alle produkter</Link></li>
            <li><Link to="/kategori/slik" className="hover:text-primary">Slik</Link></li>
            <li><Link to="/kategori/chokolade" className="hover:text-primary">Chokolade</Link></li>
            <li><Link to="/tilbud" className="hover:text-primary">Aktuelle tilbud</Link></li>
          </ul>
        </div>
        </E>
        <E id="col-account" label="Kolonne: Konto" display="block">
        <div>
          <h4 className="mb-3 text-sm font-bold uppercase tracking-wide">Konto</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/login" className="hover:text-primary">Log ind</Link></li>
            <li><Link to="/konto" className="hover:text-primary">Min konto</Link></li>
            <li><Link to="/favoritter" className="hover:text-primary">Favoritter</Link></li>
          </ul>
        </div>
        </E>
        <E id="col-info" label="Kolonne: Info" kind="text" display="block">
        <div>
          <h4 className="mb-3 text-sm font-bold uppercase tracking-wide">Info</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Fri fragt over 300 kr.</li>
            <li>100% Halal certificeret</li>
            <li>Hurtig levering</li>
          </ul>
        </div>
        </E>
      </div>
      <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
        <E id="copy" label="Copyright" kind="text">{(el) => el.text || <>© {new Date().getFullYear()} BARE 1 MERE. Alle rettigheder forbeholdes.</>}</E>
      </div>
    </footer>
  );
}
